import PropTypes from 'prop-types';

export default {
    error: PropTypes.instanceOf(Error).isRequired,
    componentStack: PropTypes.string.isRequired,
    resetError: PropTypes.func.isRequired,
};
